import React from 'react';
import './Footer.css'


const Footer = () => {
    
    return (
        <div className='bg-dark text-white p-5 footer mt-5 footer'>
            {/* link use for footer */}
<div>
        <a className='m-5' href="">Facebook</a>
         <a className='m-5' href="">E-mail</a>
         <a className='m-5' href="">Linkedin</a>
</div>
            <h1>programming Hero Learner</h1>
           
        </div>
    );
};

export default Footer;